"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _classnames = _interopRequireDefault(require("classnames"));
var _GridContext = require("./GridContext");
var _excluded = ["container", "fluid", "justify", "align", "rowGap", "rowGapLevel", "rowGapLevelSm", "rowGapLevelMd", "rowGapLevelLg", "rowGapLevelXl", "rowGapLevelXxl", "colGap", "colGapLevel", "colGapLevelSm", "colGapLevelMd", "colGapLevelLg", "colGapLevelXl", "colGapLevelXxl", "gap", "className", "style", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var gapLevelClass = function gapLevelClass(dimention, size, level) {
  return Number.isInteger(level) ? "".concat(dimention, "-gap").concat(size && "-".concat(size), "-").concat(level) : '';
};
var Grid = function Grid(_ref, ref) {
  var _ref$container = _ref.container,
    container = _ref$container === void 0 ? true : _ref$container,
    _ref$fluid = _ref.fluid,
    fluid = _ref$fluid === void 0 ? false : _ref$fluid,
    _ref$justify = _ref.justify,
    justify = _ref$justify === void 0 ? 'start' : _ref$justify,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'start' : _ref$align,
    rowGap = _ref.rowGap,
    rowGapLevel = _ref.rowGapLevel,
    rowGapLevelSm = _ref.rowGapLevelSm,
    rowGapLevelMd = _ref.rowGapLevelMd,
    rowGapLevelLg = _ref.rowGapLevelLg,
    rowGapLevelXl = _ref.rowGapLevelXl,
    rowGapLevelXxl = _ref.rowGapLevelXxl,
    colGap = _ref.colGap,
    colGapLevel = _ref.colGapLevel,
    colGapLevelSm = _ref.colGapLevelSm,
    colGapLevelMd = _ref.colGapLevelMd,
    colGapLevelLg = _ref.colGapLevelLg,
    colGapLevelXl = _ref.colGapLevelXl,
    colGapLevelXxl = _ref.colGapLevelXxl,
    gap = _ref.gap,
    className = _ref.className,
    style = _ref.style,
    children = _ref.children,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var hGap = gap !== null && gap !== void 0 ? gap : colGap;
  var vGap = gap !== null && gap !== void 0 ? gap : rowGap;
  var hMargin = !container && Number.isInteger(hGap) ? {
    marginLeft: hGap * -0.5,
    marginRight: hGap * -0.5
  } : {};
  var vMargin = !container && Number.isInteger(vGap) ? {
    marginTop: vGap * -0.5,
    marginBottom: vGap * -0.5
  } : {};
  var classes = _react["default"].useMemo(function () {
    return (0, _classnames["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({
      grid: true,
      'grid-fluid': fluid && container,
      'grid-non-container': !container
    }, "align-items-".concat(align), align), "justify-content-".concat(justify), justify), gapLevelClass('row', '', rowGapLevel), gapLevelClass('row', 'sm', rowGapLevelSm), gapLevelClass('row', 'md', rowGapLevelMd), gapLevelClass('row', 'lg', rowGapLevelLg), gapLevelClass('row', 'xl', rowGapLevelXl), gapLevelClass('row', 'xxl', rowGapLevelXxl), gapLevelClass('col', '', colGapLevel), gapLevelClass('col', 'sm', colGapLevelSm), gapLevelClass('col', 'md', colGapLevelMd), gapLevelClass('col', 'lg', colGapLevelLg), gapLevelClass('col', 'xl', colGapLevelXl), gapLevelClass('col', 'xxl', colGapLevelXxl), className);
  }, [align, className, container, fluid, justify, colGapLevel, colGapLevelSm, colGapLevelMd, colGapLevelLg, colGapLevelXl, colGapLevelXxl, rowGapLevel, rowGapLevelSm, rowGapLevelMd, rowGapLevelLg, rowGapLevelXl, rowGapLevelXxl]);
  var context = _react["default"].useMemo(function () {
    return {
      rowGap: vGap,
      colGap: hGap
    };
  }, [vGap, hGap]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: classes,
    ref: ref,
    style: _objectSpread(_objectSpread(_objectSpread({}, vMargin), hMargin), style)
  }, rest), /*#__PURE__*/_react["default"].createElement(_GridContext.GridProvider, {
    value: context
  }, children));
};
var Composed = (0, _compose["default"])(_react.memo, _react["default"].forwardRef)(Grid);
var _default = exports["default"] = Composed;